module.exports = function isBillingVisible($location) {
  var showBillingPermanent = $location.search().showBillingPermanent;

  if (showBillingPermanent === '1') {
    window.sessionStorage.setItem('showBillingPermanent', '1');
  } else if (showBillingPermanent === '0') {
    window.sessionStorage.removeItem('showBillingPermanent');
  }

  return (
    $location.search().showBilling === '1' ||
    window.sessionStorage.getItem('showBillingPermanent') === '1'
  );
};



// WEBPACK FOOTER //
// ./src/app/common/isBillingVisible.js